export const AUTH_REQUESTING = 'AUTH_REQUESTING';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';

export const AUTH_LIST_REQUESTING = 'AUTH_LIST_REQUESTING';
export const AUTH_LIST_SUCCESS = 'AUTH_LIST_SUCCESS';
export const AUTH_LIST_ERROR = 'AUTH_LIST_ERROR';

export const GENERATE_AUTH_REQUESTING = 'GENERATE_AUTH_REQUESTING';
export const GENERATE_AUTH_SUCCESS = 'GENERATE_AUTH_SUCCESS';
export const GENERATE_AUTH_ERROR = 'GENERATE_AUTH_ERROR';

export const SET_TYPE_AUTH_REQUESTING = 'SET_TYPE_AUTH_REQUESTING';
export const SET_TYPE_AUTH_SUCCESS = 'SET_TYPE_AUTH_SUCCESS';
export const SET_TYPE_AUTH_ERROR = 'SET_TYPE_AUTH_ERROR';

export const CHANGE_PASS_REQUESTING = 'CHANGE_PASS_REQUESTING';
export const CHANGE_PASS_SUCCESS = 'CHANGE_PASS_SUCCESS';
export const CHANGE_PASS_ERROR = 'CHANGE_PASS_ERROR';

export const CHANGE_USER_REQUESTING = 'CHANGE_USER_REQUESTING';
export const CHANGE_USER_SUCCESS = 'CHANGE_USER_SUCCESS';
export const CHANGE_USER_ERROR = 'CHANGE_USER_ERROR';

export const CHANGE_BANK_REQUESTING = 'CHANGE_BANK_REQUESTING';
export const CHANGE_BANK_SUCCESS = 'CHANGE_BANK_SUCCESS';
export const CHANGE_BANK_ERROR = 'CHANGE_BANK_ERROR';
